import React from "react";

const sampleData = [
  {
    slNo: 2,
    nameDetails: [
      "56100 - 177500 (Level - 9(A) & Stage - 10)",
      "Teaching Staff"
    ],
    basicSpWa: 73200,
    da53: 38796,
    hraMa: 3200,
    grossSalary: 115496,
    tpf: 0,
    gis: 110,
    faCoop: 1000,
    ptItSr: 12610,
    deduction: 12610,
    netSalary: 102886
  },
  {
    slNo: 3,
    nameDetails: [
      "68900 - 205500 (Level - 11 & Stage - 7)",
      "Teaching Staff"
    ],
    basicSpWa: 82300,
    da53: 43619,
    hraMa: 3200,
    grossSalary: 129419,
    tpf: 0,
    gis: 110,
    faCoop: 0,
    ptItSr: 13002,
    deduction: 13002,
    netSalary: 116417
  },
  {
    slNo: 4,
    nameDetails: [
      "Some other details",
      "Teaching Staff"
    ],
    basicSpWa: 59500,
    da53: 31535,
    hraMa: 3200,
    grossSalary: 94535,
    tpf: 0,
    gis: 110,
    faCoop: 1000,
    ptItSr: 10214,
    deduction: 10214,
    netSalary: 84321
  }
];

const SalaryTableExcel = () => {
  return (
    <div style={{ overflowX: "auto", padding: "1rem" }}>
      <table style={{ borderCollapse: "collapse", width: "100%", fontSize: "14px" }}>
        <thead>
          <tr>
            <th colSpan="14" style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px", padding: "10px" }}>
              SDS POLYTECHNIC COLLEGE, PATTUKOTTAI - 614 601
            </th>
          </tr>
          <tr>
            <th colSpan="14" style={{ textAlign: "center", fontWeight: "bold", fontSize: "15px", padding: "5px 10px" }}>
              AIDED SALARY STATEMENT - APRIL 2025
            </th>
          </tr>
          <tr>
            <th style={thStyle}>Sl. No.</th>
            <th style={thStyle}>
              Name /<br />
              Designation /<br />
              TPF - CPS A/c No. /<br />
              Scale of Pay /<br />
              Month & Year
            </th>
            <th style={thStyle}>BASIC / SP / WA</th>
            <th style={thStyle}>DA 53%</th>
            <th style={thStyle}>HRA / MA</th>
            <th style={thStyle}>Gross Salary</th>
            <th style={thStyle}>TPF / TPFA D / CPS (R) / CPS (A1)</th>
            <th style={thStyle}>GIS / NHIS</th>
            <th style={thStyle}>FA / COOP</th>
            <th style={thStyle}>PT / IT / SR</th>
            <th style={thStyle}>Deduction</th>
            <th style={thStyle}>Net Salary</th>
          </tr>
        </thead>
        <tbody>
          {sampleData.map((row, idx) => (
            <React.Fragment key={idx}>
              <tr>
                <td style={tdStyle}>{row.slNo}</td>
                <td style={tdStyle}>{row.nameDetails[0]}</td>
                <td style={tdStyle}>{formatNumber(row.basicSpWa)}</td>
                <td style={tdStyle}>{formatNumber(row.da53)}</td>
                <td style={tdStyle}>{formatNumber(row.hraMa)}</td>
                <td style={tdStyle}>{formatNumber(row.grossSalary)}</td>
                <td style={tdStyle}>{formatNumber(row.tpf)}</td>
                <td style={tdStyle}>{formatNumber(row.gis)}</td>
                <td style={tdStyle}>{formatNumber(row.faCoop)}</td>
                <td style={tdStyle}>{formatNumber(row.ptItSr)}</td>
                <td style={tdStyle}>{formatNumber(row.deduction)}</td>
                <td style={tdStyle}>{formatNumber(row.netSalary)}</td>
              </tr>
              <tr>
                <td></td>
                <td style={{ ...tdStyle, fontStyle: "italic", fontSize: "12px", color: "#555" }}>
                  {row.nameDetails[1]}
                </td>
                {/* Empty cells to align */}
                <td colSpan="10"></td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const thStyle = {
  border: "1px solid #000",
  padding: "8px",
  backgroundColor: "#eee",
  textAlign: "center",
  whiteSpace: "nowrap"
};

const tdStyle = {
  border: "1px solid #000",
  padding: "6px 8px",
  textAlign: "right",
  whiteSpace: "nowrap"
};

const formatNumber = (num) => {
  // Format number with commas (Indian style)
  if (num === 0) return "0.00";
  return num
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
    .replace(/(\d+),(\d{2}),(\d{3})/, "$1,$2,$3"); // rough Indian style fix
};

export default SalaryTableExcel;
